import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1ProjectPlanIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";
import {SessionContext} from "../../../../util/SessionContext";

class ProjectPlanEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let QBE = this.getQBEForRequest()
        if (!QBE) {
            QBE = {
                "ShifamedMessage": {
                    "-idoc": this.getIDOCResponse() ?? "v1.ProjectPlan-001",
                    "-id": uuidv4(),
                    "ProjectPlan": {
                        '_attributes': {
                            'limit': pageSize,
                            'sort': this.getFormattedSortSpecification(),
                            'offset': (page - 1) * pageSize
                        },
                        "QueryGroups": {
                            "QueryGroup": [
                                {
                                    "Name": "primary",
                                    "Operator": "AND",
                                    "Type": "QueryGroup",
                                    "Membership": {
                                        "Member": []
                                    }
                                }
                            ]
                        }
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.ShifamedMessage.ProjectPlan.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/project_plans",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "visibility-mode": this.getVisibilityMode(),
                "visibility-value": this.getVisibilityValue(),
                "idoc-response": this.getIDOCResponse() ?? "v1.ProjectPlan-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlan-002";
        payload.ShifamedMessage.ProjectPlan = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/project_plans",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlan-002",
                "idoc-response": "v1.ProjectPlan-002",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1ProjectPlanIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let sessionContext = new SessionContext();

        let projectPlan = {};

        if (this.getAttributeValue("PlanToCopyUSID") !== null && this.getAttributeValue("PlanToCopyUSID") !== undefined) {
            projectPlan["PlanToCopyUSID"] = this.getAttributeValue("PlanToCopyUSID");
            projectPlan["PlanToCopyNewName"] = this.getAttributeValue("PlanToCopyNewName");
            projectPlan["PlanToCopyNewProjectID"] = this.getAttributeValue("PlanToCopyNewProjectID");
            this.setIDOCResponse(null);
        } else {
            projectPlan["USID"] = this.getAttributeValue("USID");
            projectPlan["ProjectPlanID"] = this.getAttributeValue("ProjectPlanID");
            projectPlan["Name"] = this.getAttributeValue("Name");
            projectPlan["CreatedByUSID"] = sessionContext.getEmployeeUSID();
            if (sessionContext.getActiveVisibility().Mode === "Organization") {
                projectPlan["PrimaryPositionUSID"] = sessionContext.getActiveVisibility().Value;
            }
            if (sessionContext.getActiveVisibility().Mode === "Management") {
                projectPlan["PrimaryPositionUSID"] = sessionContext.getActiveVisibility().Value;
            }
            if (sessionContext.getActiveVisibility().Mode === "Position") {
                projectPlan["PrimaryPositionUSID"] = sessionContext.getActiveVisibility().Value;
            }
            if (sessionContext.getActiveVisibility().Mode === "User Group") {
                projectPlan["PrimaryUserGroupUSID"] = sessionContext.getActiveVisibility().Value;
            }
            if (sessionContext.getActiveVisibility().Mode === "Work Group") {
                projectPlan["PrimaryWorkGroupUSID"] = sessionContext.getActiveVisibility().Value;
            }
            projectPlan["Status"] = "DRAFT";
        }

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlan-001";
        payload.ShifamedMessage.ProjectPlan = projectPlan;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t3/v1/project_plans",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlan-001",
                "idoc-response": "v1.ProjectPlan-001"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1ProjectPlanIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlan-001";
        payload.ShifamedMessage.ProjectPlan = {
            "USID": this.getAttributeValue("USID")
        };

        let options = {
            method: "DELETE",
            url: "t3/v1/project_plans",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlan-001",
                "idoc-response": "v1.ProjectPlan-001",
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default ProjectPlanEnterpriseComponent;